import { useContext, useEffect, useState } from "react";
import { AdminDashboardContext } from "../../../../../context/AdminDashboardContext";
import { ModalSettingsContext } from "../../../../../context/ModalSettingsContext";

// style
import Style from "./ModalSettings.module.css";

// external components
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// my components
import Dean from "./Dean/Dean";
import Department from "./Department/Department";

// api requests Dean
import { getDean, updateDean } from "./deanApi.js";

// api request Departments
import {
  createDepartment,
  getDepartments,
  updateDepartment,
} from "./departmentApi.js";

const ModalSettings = () => {
  const { modalSettingsIsOpen, setModalSettingsIsOpen } = useContext(
    AdminDashboardContext
  );

  const [dean, setDean] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editingDepartmentId, setEditingDepartmentId] = useState(null);
  // new department
  const [newDepartmentData, setNewDepartmentData] = useState([]);

  // fetching data
  const fetchDeanData = async () => {
    try {
      const deanData = await getDean();
      setDean(deanData[0]);
    } catch (error) {
      console.error("Error fetching dean data", error);
      window.alert("Greška u dohvaćanju podataka o dekanu!");
      console.alert("Hello world");
    }
  };

  // Update an existing dean
  const handleUpdateDean = async (id, updatedDeanData) => {
    try {
      await updateDean(id, updatedDeanData);
      // Optionally, update the state or perform any other actions after updating the dean
      window.alert("Podaci o dekanu uspješno ažurirani");
    } catch (error) {
      console.error("Error updating dean:", error);
      window.alert("Greška u ažuriranju podataka o dekanu!");
    }
  };

  // DEPARTMENTS API REQUESTS
  // Fetch department data
  const fetchDepartmentData = async () => {
    try {
      const departmentsData = await getDepartments();
      setDepartments(departmentsData);
      // Handle the fetched department data as needed
    } catch (error) {
      console.error("Error fetching department data:", error);
      window.alert("Greška u dohvaćanju podataka o odjelima!");
    }
  };

  // Create a new department
  const handleCreateDepartment = async (newDepartmentData) => {
    try {
      const createdDepartment = await createDepartment(newDepartmentData);

      setDepartments((prev) => [...prev, createdDepartment]);
      clearDepartmentInputs();
      window.alert("Odjel uspješno kreiran:", createdDepartment);
    } catch (error) {
      console.error("Error creating department:", error);
      window.alert("Greška u kreiranju odjela!");
    }
  };

  // Update an existing department
  const handleUpdateDepartment = async (updatedDepartmentData) => {
    try {
      const updatedDepartment = await updateDepartment(
        editingDepartmentId,
        updatedDepartmentData
      );
      setDepartments((prev) => {
        return prev.map((department) => {
          if (department.id === editingDepartmentId)
            return { ...updatedDepartment };
          else return department;
        });
      });
      clearDepartmentInputs();
      setIsEditing(false);
      setEditingDepartmentId(null);

      window.alert("Odjel uspješno ažuriran:", updatedDepartment);
    } catch (error) {
      console.error("Error updating department:", error);
      window.alert("Greška u ažuriranju podataka o odjelu!");
    }
  };

  const closeModal = () => {
    setModalSettingsIsOpen(false);
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  useEffect(() => {
    if (modalSettingsIsOpen) {
      fetchDeanData();
      fetchDepartmentData();
    }
  }, [modalSettingsIsOpen]);

  const handleDepartmentName = (event) => {
    setNewDepartmentData({ ...newDepartmentData, name: event.target.value });
  };

  const handleDepartmentHead = (event) => {
    setNewDepartmentData({
      ...newDepartmentData,
      headName: event.target.value,
    });
  };

  const clearDepartmentInputs = () => {
    setNewDepartmentData({
      name: "",
      headName: "",
    });
  };

  return (
    <ModalSettingsContext.Provider
      value={{
        dean,
        setDean,
        handleUpdateDean,
        newDepartmentData,
        setNewDepartmentData,
        setDepartments,
        departments,
        isEditing,
        setIsEditing,
        editingDepartmentId,
        setEditingDepartmentId,
      }}
    >
      <div className={Style.ModalContainerOverlay}>
        <div className={Style.Modal}>
          <div className={Style.ModalTopBar}>
            <button
              style={{ border: "none", backgroundColor: "transparent" }}
              onClick={() => closeModal()}
            >
              <FontAwesomeIcon icon={faXmark} size="1x" />
            </button>
          </div>

          <h2 className="title-font">Postavke</h2>

          <div className={Style.ModalLine}></div>

          <div className={Style.ModalContent}>
            <h4 className="title-font" style={{ marginTop: "10px" }}>
              Dekan
            </h4>

            <div className={Style.DeanInfo}>
              <Dean />
            </div>

            <h4 className="title-font" style={{ marginTop: "10px" }}>
              Zavodi
            </h4>

            <div className={Style.DepartmentsInfo}>
              {departments &&
                departments.map((department) => (
                  <Department
                    key={department.id}
                    name={department.name}
                    headName={department.headName}
                    departmentName={department.name}
                    headOfDepartmentName={department.headName}
                    departmentIdNumber={department.id}
                  />
                ))}
            </div>
            {/* ADDIG NEW DEPARTMENT */}
            <div className={Style.NewDepartmentContainer}>
              <input
                className={Style.NewDepartmentName}
                onChange={handleDepartmentName}
                type="text"
                placeholder="ime zavoda..."
                value={newDepartmentData.name}
              ></input>
              <input
                className={Style.NewDepartmentHead}
                onChange={handleDepartmentHead}
                type="text"
                placeholder="ime nositelja zavoda..."
                value={newDepartmentData.headName}
              ></input>
              <button
                className={Style.AddNewDepartmentButton}
                onClick={() =>
                  !isEditing
                    ? handleCreateDepartment(newDepartmentData)
                    : handleUpdateDepartment(newDepartmentData)
                }
              >
                {!isEditing ? "DODAJ NOVI ZAVOD" : "AŽURIRAJ ZAVOD"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </ModalSettingsContext.Provider>
  );
};

export default ModalSettings;
